import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { isArray } from "../../Libs/CustomMethods/customMethods";

import { useDispatch, useSelector } from "react-redux";

import {
  getClientSystemVariable,
  createClientSystemVariable,
  editClientSystemVariable,
  resetClientSystemVariable,
  resetClientSystemVariables,
  resetError,
} from "../../store/actions";

const NewClientSystemVariable = ({ t }) => {
  let { idCompany, idClientSystemVariable } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataClientSystemVariableGetSet,
    dataClientSystemVariableEditCreate,
    loadingClientSystemVariable,
    loadingClientSystemVariableEditCreate,
    successClientSystemVariable,
    errorClientSystemVariable,
  } = useSelector((state) => state.ClientSystemVariables);

  const [clientSystemVariableValues, setClientSystemVariableValues] = useState({
    name: "",
    value: "",
    editable: true,
  });

  const [newFields, setNewFields] = useState({ editable: true });
  const [enableSubmit, setEnableSubmit] = useState(false);

  const handleCreateEditClientSystemVariable = () => {
    if (idClientSystemVariable) {
      dispatch(editClientSystemVariable(idClientSystemVariable, newFields));
    } else {
      dispatch(createClientSystemVariable(newFields));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successClientSystemVariable &&
      dispatch(resetClientSystemVariable()) &&
      dispatch(resetClientSystemVariables()) &&
      history.push("/systemvariables"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetClientSystemVariable());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idClientSystemVariable) {
      dispatch(
        getClientSystemVariable(idClientSystemVariable, idCompany, false)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idClientSystemVariable]);

  useEffect(() => {
    if (idClientSystemVariable && dataClientSystemVariableGetSet?.data) {
      setClientSystemVariableValues((previous) => ({
        ...previous,
        name: dataClientSystemVariableGetSet.data?.name,
        value: dataClientSystemVariableGetSet.data?.value,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClientSystemVariableGetSet]);

  useEffect(() => {
    if (
      dataClientSystemVariableEditCreate &&
      dataClientSystemVariableEditCreate.message
    ) {
      showToast("success", t(dataClientSystemVariableEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successClientSystemVariable]);

  useEffect(() => {
    if (isArray(errorClientSystemVariable)) {
      errorClientSystemVariable.map((error) =>
        showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorClientSystemVariable) {
        showToast("error", t(errorClientSystemVariable));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorClientSystemVariable]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/systemvariables"
            path={
              idClientSystemVariable
                ? "/systemvariable/" + idClientSystemVariable
                : "/systemvariable"
            }
            title={t("System Variables")}
            breadcrumbItem={
              !idClientSystemVariable
                ? t("Create System Variable")
                : t("Edit System Variable")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditClientSystemVariable}>
                    <Row>
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("System Variable name")}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                clientSystemVariableValues.name
                              ) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  name: e.target.value,
                                }));
                              }
                            }}
                            value={clientSystemVariableValues.name}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            label={t("Value") + " *"}
                            id="value"
                            name="value"
                            type="text"
                            className="form-control"
                            placeholder={t("Value")}
                            value={clientSystemVariableValues.value}
                            onChange={(e) => {
                              if (
                                e.target.value ===
                                clientSystemVariableValues.value
                              ) {
                                delete newFields.value;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  value: e.target.value,
                                }));
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingClientSystemVariableEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/systemvariables">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetClientSystemVariable())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewClientSystemVariable);
